import { jsxs as f, jsx as i } from "react/jsx-runtime";
import { E as g, S as m } from "./icons.types-0722eef5.js";
function w({ title: o, titleId: r, size: a, width: h, height: s, extended: l = !1, ...n }) {
  const c = l ? g : m, t = a ? c[a] : h || c[l ? "s" : "l"], e = a ? c[a] : s || c[l ? "s" : "l"];
  return /* @__PURE__ */ f(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: t,
      height: e,
      "aria-labelledby": r,
      ...n,
      children: [
        o ? /* @__PURE__ */ i("title", { id: r, children: o }) : null,
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M10.667 23.666h10.666a.968.968 0 0 0 .713-.287.968.968 0 0 0 .287-.712.968.968 0 0 0-.287-.713.967.967 0 0 0-.713-.287H10.667a.968.968 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.095.52.287.712.191.192.429.287.713.287Zm-2.257 5a2.326 2.326 0 0 1-1.71-.7 2.326 2.326 0 0 1-.7-1.71V5.744c0-.674.233-1.244.7-1.71a2.327 2.327 0 0 1 1.71-.7h9.593c.32 0 .63.062.927.186.296.125.554.297.773.516l5.594 5.595c.22.218.391.476.516.773.125.296.187.605.187.927v14.925c0 .674-.233 1.244-.7 1.71-.467.467-1.037.7-1.71.7H8.41ZM18 10.128V5.333H8.41a.392.392 0 0 0-.282.128.392.392 0 0 0-.128.283v20.512c0 .103.043.197.128.282.086.086.18.129.282.129h15.18a.393.393 0 0 0 .282-.129.393.393 0 0 0 .128-.282V11.333h-4.795c-.343 0-.63-.115-.86-.345a1.168 1.168 0 0 1-.345-.86Z"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            d: "M21.333 19.666H10.667a.968.968 0 0 1-.713-.287.968.968 0 0 1-.287-.712c0-.284.095-.522.287-.713a.968.968 0 0 1 .713-.287h10.666c.284 0 .522.095.713.287a.968.968 0 0 1 .287.713.968.968 0 0 1-.287.712.968.968 0 0 1-.713.287ZM21.333 15.666H10.667a.968.968 0 0 1-.713-.287.968.968 0 0 1-.287-.712c0-.284.095-.522.287-.713a.968.968 0 0 1 .713-.287h10.666c.284 0 .522.095.713.287a.968.968 0 0 1 .287.713.968.968 0 0 1-.287.712.968.968 0 0 1-.713.287Z"
          }
        )
      ]
    }
  );
}
export {
  w as File
};
